<template>
  <keep-alive>
    <component
      :is="registerSteps[currentStep]"
      v-on-click-outside="handleClickOutside"
      @close="handleClose"
      @change-step="handleStepChanging"
    />
  </keep-alive>
</template>

<script>
  import PickPositions from '@/containers/tenders/create/PickPositions';
  import SpecifyInfo from '@/containers/tenders/create/SpecifyInfo';
  import Invite from '@/containers/tenders/create/Invite';
  import { mapActions, mapGetters, mapState } from 'vuex';
  import Confirm from '@/components/ui/Confirm';
  import { handleModalClose } from '@/utils/click-outside';

  export default {
    name: 'CreateModal',
    components: {
      Confirm,
    },
    data() {
      return {
        currentStep: 1,
      };
    },
    created() {
      this.currentStep = this.context?.step || 1;
    },
    computed: {
      ...mapGetters('tenderEdit', ['editId']),
      ...mapState('modal', ['context']),
      registerSteps() {
        return {
          1: PickPositions,
          2: SpecifyInfo,
          3: Invite,
        };
      },
    },
    methods: {
      ...mapActions('modal', ['closeModal']),
      ...mapActions({
        confirm: 'confirmModal/openModal',
      }),
      handleStepChanging(step) {
        this.currentStep = step;
      },
      handleClose() {
        this.confirm({
          title: this.$t('Cancel the changes?'),
          actionText: this.$t('Cancel'),
          cancelText: this.$t('Return to edit'),
          description: this.$t(
            'You will not be able to restore the changes if you close this window. We are still working on the drafts functionality.'
          ),
          action: () => {
            this.closeModal();
          },
        });
      },
      handleClickOutside(event) {
        handleModalClose(event, () => this.handleClose());
      },
    },
  };
</script>
